export default __webpack_public_path__ + "static/media/rightArrow.5c177a9a.svg";